import { useEffect, useState } from "react";
import { Coin } from "@phosphor-icons/react";

const API = process.env.REACT_APP_BACKEND_URL;
const fmt = (n) => new Intl.NumberFormat("es-MX").format(Math.round(n || 0));

/**
 * DydProfileBlock — bloque visual con el balance DYD, ranking, breakdown%.
 * Llama a /api/users/{userId}/dyd-public (público, sin auth).
 */
export default function DydProfileBlock({ userId }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    fetch(`${API}/api/users/${userId}/dyd-public`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => alive && setData(d))
      .catch(() => {});
    return () => { alive = false; };
  }, [userId]);

  if (!data) return null;
  const total = data.lifetime_earned || 0;
  return (
    <div className="bg-gradient-to-br from-[#CCFF00]/10 to-amber-500/5 border border-[#CCFF00]/30 p-5" data-testid="dyd-profile-block">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <Coin size={28} weight="fill" className="text-[#CCFF00]" />
          <div>
            <p className="text-[10px] tracking-[0.3em] uppercase font-bold text-[#CCFF00]">DYD Moneda</p>
            <p className="font-['Barlow_Condensed'] text-5xl font-black text-[#CCFF00] leading-none">{fmt(data.balance)} <span className="text-xl">DYD</span></p>
            <p className="text-[10px] text-gray-400 mt-1">
              Ganados: <span className="text-green-400 font-bold">{fmt(data.lifetime_earned)}</span> ·
              Gastados: <span className="text-red-400 font-bold">{fmt(data.lifetime_spent)}</span>
            </p>
          </div>
        </div>
        {data.rank_position && (
          <div className="text-right">
            <p className="font-['Barlow_Condensed'] text-5xl font-black text-white leading-none">#{data.rank_position}</p>
            <p className="text-[10px] text-gray-500 uppercase tracking-wider mt-1">Ranking DYD</p>
          </div>
        )}
      </div>
      {data.breakdown?.length > 0 && (
        <div className="mt-4 pt-4 border-t border-white/5">
          <p className="text-[10px] tracking-[0.2em] uppercase font-semibold text-gray-500 mb-2">Origen de tus DYD</p>
          {/* Stacked bar */}
          <div className="flex h-2 rounded overflow-hidden bg-black/40 mb-2" data-testid="dyd-stacked-bar">
            {data.breakdown.map((b, i) => (
              <div key={b.label} style={{ width: `${b.percent}%`, backgroundColor: stackColor(i) }} title={`${b.label}: ${b.percent}%`} />
            ))}
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-1">
            {data.breakdown.slice(0, 6).map((b, i) => (
              <div key={b.label} className="flex items-center gap-1.5 text-[10px]" data-testid={`dyd-source-${b.label.toLowerCase()}`}>
                <span className="w-2 h-2 rounded-sm" style={{ backgroundColor: stackColor(i) }} />
                <span className="text-gray-300 uppercase tracking-wider truncate">{b.label}</span>
                <span className="text-[#CCFF00] font-bold ml-auto">{b.percent}%</span>
              </div>
            ))}
          </div>
          <p className="text-[10px] text-gray-500 mt-2">Total ganado: <span className="text-white font-bold">{fmt(total)} DYD</span></p>
        </div>
      )}
    </div>
  );
}

function stackColor(i) {
  const palette = ["#CCFF00", "#22C55E", "#3B82F6", "#F59E0B", "#A855F7", "#EC4899", "#EF4444", "#06B6D4"];
  return palette[i % palette.length];
}
